import locale from "localization/en";
import styles from "../dry-stock.module.scss";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { filter } from "lodash";
import { lpgSalesColumn } from "./lpg-sales-column";
import { lpgSalesMapper } from "./lpg-sales.mapper";
import Big from "big.js";

const LpgSales = ({ shift }) => {
  const lpgs = filter(shift?.transactionItem.nonFuel, { type: "lpg" });
  const lpgPremiumDiscount = filter(shift?.transactionPaymentMethod?.cash, {
    type: "lpg",
  });

  const formattedList = lpgs.map((lpg) => {
    const premiumDiscount = lpgPremiumDiscount.find((premium) => premium.sku === lpg.sku);
    let vatExemptAmount = lpg.vatExempt12percent;
    let totalDiscount =
      Number(
        Big(lpg.originalTotalAmount)
          .minus(lpg.netTotalAmount)
          .minus(Math.abs(lpg.vatExempt12percent))
          .mul(-1)
          .round(2),
      ) + vatExemptAmount;
    const finalAmount = lpg.originalTotalAmount + totalDiscount + vatExemptAmount;

    return {
      ...lpg,
      totalDiscount,
      finalAmount,
      premiumDiscount,
      vatExemptAmount,
    };
  });

  const { table } = useDataTable({
    value: formattedList,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "nonFuel",
      name: "dryStockSales",
      mapper: (val) => lpgSalesMapper({ val }),
      columns: lpgSalesColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.lpgSales}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default LpgSales;
